/**
* Animated Text JS
* -----------------------------------------------------------------------------
*
* All the JS for the Animated Text component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'animated-text',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.animated-text' ).each( function() {
        const leftText = $( this ).find( '.left-text' );
        const rightText = $( this ).find( '.right-text' );
        const content = $( this ).find( '.wysiwyg' );

        // let top = getComputedStyle( document.documentElement ).getPropertyValue( '--topOffset' );
        // top = top.match( /[0-9]+.*[0-9]+/, '' );
        // top = top.join( '' );
        // top = top.replace( 'px', '' );
        // console.log( top );

        let mobile = false;
        let loggedIn = false;
        if ( window.innerWidth < 1024 ) {
          mobile = true;
        }
        if ( $( '.logged-in' ).length > 0 ) {
          loggedIn = true;
        }

        let top = '88px';
        if ( mobile === true ) {
          top = '64px';
        }
        if ( loggedIn === true && mobile === false ) {
          top = '120px';
        }
        if ( mobile === true && loggedIn === true ) {
          top = '110px';
        }
        $( window ).on( 'resize', function() {
          if ( mobile === true ) {
            top = '64px';
          }
          if ( loggedIn === true && mobile === false ) {
            top = '120px';
          }
          if ( mobile === true && loggedIn === true ) {
            top = '110px';
          }
        } );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top top+=' + top + 'px',
            end: 'bottom top',
            pin: true,
            scrub: 0.5,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'js-animated' ),
          },
        } );
        tl.from( leftText, {xPercent: -100, opacity: 0} )
            .from( rightText, {xPercent: 100, opacity: 0}, '<' )
            .from( content, {yPercent: 100, opacity: 0} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'animated-text', COMPONENT );
} )( app );
